import { render, staticRenderFns } from "./AndyMascot.vue?vue&type=template&id=6648988e&scoped=true"
import script from "./AndyMascot.vue?vue&type=script&lang=js"
export * from "./AndyMascot.vue?vue&type=script&lang=js"
import style0 from "./AndyMascot.vue?vue&type=style&index=0&id=6648988e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6648988e",
  null
  
)

export default component.exports